<div class="sections">
    <div>
        <form [formGroup]="form">
            <div class="field">
                <h4>Business name</h4>
                <mat-form-field appearance="outline" appFormFieldFilled>
                    <input matInput
                           formControlName="businessName"
                           autocomplete="off"
                           name="avoidSearch"
                           (focus)="activeExplanationChange('businessName', true)"
                           (focusout)="activeExplanationChange('businessName', false)"
                           enterkeyhint="next"
                    />
                    <mat-error *ngIf="formControlError(form, 'businessName') === 'required'">Business name is required</mat-error>
                </mat-form-field>
            </div>
            <div class="field multiple">
                <div class="flex-fill">
                    <div class="d-flex justify-content-between align-items-center">
                        <h4>Address</h4>
                        <h4 class="simple-text-button" (click)="clearAddress()" *ngIf="form.controls.address.value !== null">Clear</h4>
                    </div>
                    <address-form-field #addressInput
                            formControlName="address"
                            placeholder="Enter at least 7 characters for autocomplete"
                            [error]="addressError(form, 'address')"
                            (onFocus)="activeExplanationChange('address', $event)"
                    ></address-form-field>
                </div>
                <div style="width: 150px">
                    <h4>Unit</h4>
                    <mat-form-field appearance="outline" appFormFieldFilled>
                        <input matInput
                               formControlName="unit"
                               autocomplete="off"
                               name="avoidSearch"
                               (focus)="activeExplanationChange('unit', true)"
                               (focusout)="activeExplanationChange('unit', false)"
                               enterkeyhint="next"
                        />
                    </mat-form-field>
                </div>
            </div>
            <div class="field">
                <h4>Phone number</h4>
                <mat-form-field appearance="outline" appFormFieldFilled>
                    <input matInput
                           formControlName="phoneNumber"
                           autocomplete="off"
                           name="avoidSearch"
                           (focus)="activeExplanationChange('phoneNumber', true)"
                           (focusout)="activeExplanationChange('phoneNumber', false)"
                           enterkeyhint="next"
                           inputmode="tel"
                           mask="(000) 000-0000"
                    />
                    <mat-error *ngIf="formControlError(form, 'phoneNumber') === 'required'">Phone number is required</mat-error>
                    <mat-error *ngIf="formControlError(form, 'phoneNumber') === 'invalid'">Invalid phone number</mat-error>
                </mat-form-field>
            </div>
            <div class="field multiple">

                <div class="flex-fill">
                    <h4>Business creation date</h4>
                    <mat-form-field appearance="outline"
                                    class="date-input"
                                    appFormFieldFilled
                                    (click)="datePicker.open()"
                    >
                        <img class="img-calendar" matPrefix
                             src="../../../assets/icons/calendar.svg"
                             width="16" height="16">
                        <input #dateInput
                               matInput
                               formControlName="creationDate"
                               placeholder="MM/DD/YYYY"
                               inputmode="numeric"
                               [matDatepicker]="datePicker"
                               autocomplete="off"
                               name="avoidSearch"
                               enterkeyhint="next"
                               (focus)="activeExplanationChange('creationDate', true)"
                               (focusout)="activeExplanationChange('creationDate', false); fixDate('creationDate', form)"
                               (input)="maskInput($event, form.controls['creationDate'], '00/00/0000')"
                        >
                        <mat-datepicker #datePicker
                                        [disabled]="false"
                                        (opened)="activeExplanationChange('creationDatePicker', true)"
                                        (closed)="activeExplanationChange('creationDatePicker', false)"
                        ></mat-datepicker>
                        <mat-error *ngIf="formControlError(form, 'creationDate') === 'required'">Creation date is required</mat-error>
                        <mat-error *ngIf="formControlError(form, 'creationDate') === 'matDatepickerParse'">Invalid date</mat-error>
                        <mat-error *ngIf="formControlError(form, 'creationDate') === 'future'">Choose a date in the past</mat-error>
                    </mat-form-field>
                </div>
                <div class="flex-fill">
                    <h4>Time zone</h4>
                    <mat-form-field appearance="outline" appFormFieldFilled>
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="trigger-area" (click)="timezoneAutocomplete.isOpen ? timezoneTrigger.closePanel() : timezoneTrigger.openPanel()"></div>
                            <input matInput #timezoneInput
                                   [matAutocomplete]="timezoneAutocomplete"
                                   #timezoneTrigger="matAutocompleteTrigger"
                                   [anchorAutocompleteOnScroll]="timezoneTrigger"
                                   formControlName="timezone"
                                   autocomplete="off"
                                   name="avoidSearch"
                                   (focus)="timezoneInput.blur()"
                                   enterkeyhint="next"
                            >
                            <mat-icon matSuffix class="rotate" [class.do]="timezoneAutocomplete.isOpen">expand_more</mat-icon>
                        </div>
                        <mat-autocomplete #timezoneAutocomplete="matAutocomplete"
                                          (opened)="activeExplanationChange('timezone', true)"
                                          (closed)="activeExplanationChange('timezone', false)"
                        >
                            <mat-option [value]="timezone" *ngFor="let timezone of timezones">
                                {{ timezone }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="formControlError(form, 'timezone') === 'required'">Timezone is required</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </form>
        <div class="actions">
            <button mat-stroked-button color="primary" *ngIf="showSameAsLegalButton$ | async" (click)="copyFromLegalInformation()">Same as legal</button>
            <button mat-flat-button color="primary" (click)="nextClick.emit()">{{ (progress === 100) ? 'Finalize' : 'Next' }}</button>
        </div>
    </div>

    <div class="divider"></div>

    <div>
        <div class="info"#containerDiv>
            <div class="background" #backgroundDiv [ngStyle]="bgStyles"></div>

            <div class="field-explanation" #itemDiv [class.active]="activeIndex === i" *ngFor="let field of fieldExplanations; let i = index" [id]="'nuvei_app_' + field.id">
                <p>{{ field.title }}</p>
                <h4>{{ field.explanation }}</h4>
            </div>
        </div>
    </div>
</div>